import { INFINITY_SUGGESTION_MODE, type InfinitySuggestionMode } from 'src/data/infinity/const';
import type { Variation } from 'src/data/variation';
import { countWords } from 'src/lib/string';

import type { InfinitySuggestion } from './types';

export const mapVariationToSuggestion = ({
  id,
  generationTool,
  copyText,
  score,
  performancePredictionsScoreLocked,
}: Variation): InfinitySuggestion => ({
  id,
  generationTool,
  copyText,
  score,
  performancePredictionsScoreLocked,
});

export const deduceVariationCount = (
  mode: InfinitySuggestionMode,
  originalText: string
): number => {
  // we need only 1 suggestion for "apply brand voice" mode
  if (mode === INFINITY_SUGGESTION_MODE.applyBrandVoice) {
    return 1;
  }

  const wordsCount = countWords(originalText);
  if (wordsCount > 50) {
    return 1;
  }
  if (wordsCount > 20) {
    return 2;
  }
  return 3;
};
